
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'BookDownloadButton',
  props: {
    product: {
      type: Object,
    },
    url: {
      type: String,
    },
  },
  data() {
    return {
      productItem: {},
      priceData: {},
      urlAddress: '',
      isLoading: false,
    }
  },
 async fetch() {
    this.productItem = await this.$props.product
    this.urlAddress = this.$props.url
    this.priceData = this.$options.filters.priceData(this.product)
  },
  computed: {
    ...mapGetters({
      length: 'cart/getNumberOfProducts',
      showModal: 'cart/showAdded',
    }),
  },
  mounted(){
    if (Object.keys(this.priceData).length > 0 && window) {
      // TRACKING
      console.log('Product View (DOWNLOAD BUTTON)', this.priceData.productName)
      
      // Set up data
      const data = {
        product_id: this.priceData.sku,
        sku: this.priceData.sku,
        name: this.priceData.productName,
        price: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
        discount: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.product.prices) === this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted) ? 0 : this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.product.prices) - this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
        coupon: this.priceData.offerCode,
        category: this.priceData.productType,
        quantity: 1,
        currency: this.$nuxt.$options.filters.currencyCodeFromLabel(),
      }
      const dataGTM = {
        item_id: this.priceData.sku,
        item_name: this.priceData.productName,
        price: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
        discount: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.product.prices) === this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted) ? 0 : this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.product.prices) - this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
        coupon: this.priceData.offerCode,
        quantity: 1,
        item_category: this.priceData.productType,
      }
      // For GTM
      const items = []
      items.push(dataGTM)

      // Track via rudderstack
      this.$rs.track("Product Viewed",
        data
      )

      // Track via GTM
      this.$gtm.push({
        event: 'view_item',
        ecommerce: {
          currency: this.$nuxt.$options.filters.currencyCodeFromLabel(),
          value: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
          items
        }
      });
    }
  },
  methods: {
    ...mapActions({
      addToCart: 'cart/addToCartServer',
    }),
    addToCartLoading(data){
      this.isLoading = true
      return this.addToCart(data).then(res => {
        this.isLoading = false
      }).catch(err => {
        console.log(err);
        this.isLoading = false
      })
    }
  },
}
